import React, { useContext, useEffect } from "react";
import { AuthContext } from "../AuthContext/AuthContext";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom";

function CustomerService() {
  const { user } = useContext(AuthContext);
  const History = useHistory();

  const location = useLocation();

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  useEffect(async () => {
    await sleep(3000);
    const Pathname = location.pathname;
    localStorage.setItem("Pathname", Pathname);
  }, []);

  useEffect(() => {
    if (
      jwt_decode(user.access).urole != "CUSSERVICE" &&
      jwt_decode(user.access).urole != "ADMIN"
    ) {
      History.push("/topic");
      window.alert("ACCESS DENIED!");
    } else {
      return;
    }
  }, [user.access, History]);
  return <div>CustomerService</div>;
}

export default CustomerService;
